import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import GET_CLASSIFICATION_PERFORMANCE_ITEM_REPORT from '../queries/getClassificationPerformanceItemReportQuery';
import { DataCorrelationMapper } from '../mappers/DataCorrelationMapper';
import { dataCorrelationUtils } from '../utils/dataCorrelationUtils';
import useDataCorrelationPagination from './useDataCorrelationPagination';

const useDataCorrelationReport = (selectedFilter, selectedPracticeArea) => {
  const {
    data: classificationPerformanceItemReportData,
    loading: classificationPerformanceItemReportLoading,
    error: classificationPerformanceItemReportError
  } = useQuery(GET_CLASSIFICATION_PERFORMANCE_ITEM_REPORT, {
    skip: !selectedFilter.practiceAreaId || !selectedFilter.classificationMetricId,
    variables: {
      classificationPerformanceItemId: selectedFilter.classificationMetricId
    }
  });

  const {
    practiceAreaReportsData,
    practiceAreaReportLoading,
    practiceAreaReportError,
    totalGraphCount,
    fetchMoreData
  } = useDataCorrelationPagination(selectedFilter);

  const mergedReportData = useMemo(() => {
    if (!classificationPerformanceItemReportData || !practiceAreaReportsData) {
      return [];
    }

    const classificationData = DataCorrelationMapper.toGraphData(
      classificationPerformanceItemReportData.classificationPerformanceItemsReport
    );

    const practiceAreaReports =
      DataCorrelationMapper.toPracticeAreaReportData(practiceAreaReportsData);

    return dataCorrelationUtils.mergeReportData(
      classificationData,
      practiceAreaReports,
      selectedPracticeArea
    );
  }, [classificationPerformanceItemReportData, practiceAreaReportsData, selectedPracticeArea]);

  const error = classificationPerformanceItemReportError || practiceAreaReportError;

  return {
    mergedReportData,
    isLoading: practiceAreaReportLoading || classificationPerformanceItemReportLoading,
    error,
    totalGraphCount,
    fetchMoreData
  };
};

export default useDataCorrelationReport;
